import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import { clearUserInfo, getUserInfo } from '../utils/login'
let userInfo = null

const http = (method, postType, path, data, isCatch) => {
    return new Promise((resolve, reject) => {
        const SEVER_PATH = window.SEVER_PATH

        if (!userInfo) {
            userInfo = getUserInfo()
        }
        const headers = {
            module: 'begonia',
            channel: 'h5',
            ['content-Type']: 'application/json',
        }
        if (postType === 'form') {
            headers['content-Type'] = 'application/x-www-form-urlencoded'
        }
        if (userInfo) headers['token'] = userInfo.token
        if (data && data.token) headers['token'] = data.token

        const params = postType === 'form' ? qs.stringify(data) : data
        axios({
            method,
            url: SEVER_PATH + path,
            headers: headers,
            data: params,
            withCredentials: true,
        })
            .then((res) => {
                if (res.status == 200 && res.data.code === 200) {
                    resolve(res.data)
                } else if (res.data.code === 401) {
                    clearUserInfo()
                    window.location.reload()
                } else {
                    if (isCatch) {
                        reject(res)
                    } else {
                        Toast(res.data.message)
                    }
                }
            })
            .catch((err) => {
                if (isCatch) {
                    reject(err)
                }
            })
    })
}

/**
 * 用户处理
 */
// 根据code 获取用户信息
export const loginByWechat = function (data) {
    return http('POST', 'form', '/user/loginByWechat', data, true)
}
// 用户关系绑定
export const bindWalle = function (data) {
    return http('POST', 'form', '/user/bindWalle', data)
}
// 手机号绑定
export const bindTel = function (data) {
    return http('POST', 'form', '/user/bindTel?telNo=' + data)
}
export const userTelMod = (data) => {
    return http('POST', 'form', '/user/bindTel', data)
}

/**
 * 课程相关接口
 */
// 获取课程详情
export const getCourseInfo = function (packageNo) {
    return http('POST', 'form', '/coursePackage/get', { packageNo: packageNo })
}
// 获取课程目录
export const queryByPackage = function (packageNo) {
    return http('POST', 'form', '/course/queryByPackage', { packageNo: packageNo })
}
// 获取领取课程状态
export const getPaidStatus = function (data) {
    return http('POST', 'form', '/coursePackage/getPaidStatus', data)
}
// 领取课程
export const receiveCourse = function (data) {
    return http('POST', 'form', '/coursePackage/receive', data)
}
// 获取播放地址
export const getPlayUrl = function (data) {
    return http('POST', 'form', '/live/getPlayUrl', data)
}
// 获取直播课程 登录参数
export const getLiveInfo = function (courseToken) {
    return http('POST', 'form', '/live/sign', { courseToken })
}

export const getLiveCourse = function (data) {
    return http('POST', 'form', '/live/sign', data)
}
// 获取直播课程 相关信息
export const getCourseLiveInfo = function (data) {
    return http('POST', 'form', '/live/getCourseInfo', data)
}
// 直播心跳
export const liveHeart = function (data) {
    return http('POST', 'form', '/live/heart', data, true)
}

/**
 *  获取支付数据
 *  payFeeType 1 全款 2定金 3尾款
 *  没有传默认 全款
 */
export const fetchOrder = function (data) {
    return http('POST', '', '/trade/fetchOrder', data)
}

export const getShortValue = function (key) {
    return http('POST', '', `/plugin/sk/${key}`, {})
}

// 支付状态
export const queryOrder = function (data) {
    return http('POST', 'form', '/trade/queryOrder', data)
}
// 短链接 获取支付宝地址
export const shortText = function (sk) {
    return http('POST', 'form', '/shortText/sk/' + sk)
}
// 获取当前可用支付类型
export const getPayType = function () {
    return http('POST', 'form', '/trade/getProvider')
}
// 微信支付
export const wxPay = function (params, cb) {
    function onBridgeReady() {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', params, cb)
    }
    if (typeof WeixinJSBridge == 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
        }
    } else {
        onBridgeReady()
    }
}

// 用户同意协议
export const agreeAgreement = function (agreeNo) {
    return http('POST', '', '/trade/agreeAgreement?agreeNo=' + agreeNo, null, true)
}

//  获取直播推送商品
export const liveCoursePackage = function (data) {
    return http('POST', 'form', '/coursePackage/live', data)
}

// 分享
export const getShareRank = function (data) {
    return http('POST', 'form', '/live/shareRank', data)
}
export const userShareAction = function (data) {
    return http('POST', 'form', '/live/shareAction', data, true)
}
export const userShareInvited = function (data) {
    return http('POST', 'form', '/live/shareInvited', data, true)
}
export const getWxJsapiTicket = function (data) {
    return http('POST', 'form', `/wxMp/jsapiTicket/${window.WX_APPID}`, data, true)
}

// 时长打点
export const liveAttend = function (cid) {
    const userInfo = getUserInfo()
    const params = {
        uid: userInfo.id,
        vt: 2,
        dt: 5,
        cid,
    }
    return http('POST', 'form', '/live/attend', params, true)
}

// 购买状态
export const getUserPaid = function (params) {
    return http('POST', 'form', '/user/paid', params)
}

export const getUserCoursePackage = function (userId) {
    return http('POST', 'form', '/coursePackageUser/myQACourse?userId=' + userId)
}

// 获取 订单信息
export const getAgreement = function (data) {
    let url = ''
    if (data.agreeNo) {
        url = `/trade/getAgreement?agreeNo=${data.agreeNo || ''}`
    } else {
        url = `/trade/getAgreement?agreementId=${data.agmId || ''}`
    }
    return http('POST', '', url)
}

export const getCategory = function (categoryId) {
    return http('POST', '', '/courseCategory/get?categoryId=' + categoryId)
}

// 返回公众号二维码
export const getFollowMpQrcode = function (data) {
    return http('POST', 'form', '/coursePackage/followMp', data)
}

// 获取 公众号关注状态
export const getSubscribeStatus = function (data) {
    return http('POST', 'form', '/wxMp/subscribeStatus/' + window.WX_APPID, data)
}

// 验证码登录
export const getCaptcha = function (data) {
    return http('POST', 'form', '/user/getCaptcha', data)
}
export const loginByCaptcha = function (data) {
    return http('POST', 'form', '/user/loginByCaptcha', data)
}

// 直播间禁言
export const getLiveForbidden = function (userId) {
    return http('POST', '', `/live/forbidden?userId=${userId}`)
}

// Ticket 登录
export const loginByAuthTicket = function (data) {
    return http('POST', 'form', '/user/loginByAuthTicket', data)
}

// 激活模考
export const activeMock = function (data) {
    return http('POST', 'form', '/plugin/activeMockExam', data)
}

// 激活打卡
export const activePdArticle = function (data) {
    return http('POST', 'form', '/plugin/activePdArticle', data)
}

// 激活商品
export const activeProduct = function (data) {
    return http('POST', 'form', '/plugin/active', data)
}

export const newActiveProduct = function (data) {
    return http('POST', '', '/plugin/activeNew', data)
}
export const getActiveProduct = function (data) {
    return http('POST', '', '/plugin/active/record', data)
}

// 查询分期信息
export const getQuotaPayInfo = function (data) {
    return http('POST', 'form', '/trade/getQuotaPay', data)
}

export const getOAuthTpTicket = function (data) {
    return http('POST', '', '/user/getOAuthTpTicket', data, true)
}
export const userLogin = function (data) {
    return http('POST', '', '/user/login', data, true)
}

export const getActiveQualification = function (data) {
    return http('POST', 'form', '/plugin/activeQualification', data)
}

// 活动接口
export const getActivitySchoolStatus = function (data) {
    return http('POST', 'form', '/activity/school/status', data)
}
export const getActivitySchoolCaptcha = function (data) {
    return http('POST', 'form', '/activity/school/captcha', data)
}
export const getActivitySchoolApply = function (data) {
    return http('POST', '', '/activity/school/apply', data)
}

// 校企合作-学员信息
export const getUserEducation = function (data) {
    return http('POST', 'form', '/user/education/get', data)
}
export const saveUserEducation = function (data) {
    return http('POST', '', '/user/education/save', data)
}

// 商品信息
export const getProductInfo = function (data) {
    return http('POST', 'form', '/product/get', data)
}
export const getProductPaidStatus = function (data) {
    return http('POST', 'form', '/product/getPaidStatus', data)
}
export const getProductQrcode = function (data) {
    return http('POST', 'form', '/product/getQrcode', data)
}

export const getTradeStatus = function (data) {
    return http('POST', '', '/trade/status', data, true)
}

export const getAdditionalActivity = function (data) {
    return http('POST', 'form', '/plugin/additional/activity', data)
}

export const receiveAdditionalActivity = function (data) {
    return http('POST', '', '/plugin/additional/receive', data)
}

export const getUserCert = function (data) {
    return http('POST', 'form', `/plugin/user/cert`, data, true)
}

export const getUserContactState = function (data) {
    return http('POST', 'form', `/user/contact/check`, data, true)
}

export const getMiniUrlLink = function (appid, data) {
    return http('POST', '', `/wxMa/urlLink/${appid}`, data, true)
}

// 合同签约
export const signAgreement = function (data) {
    return http('POST', '', '/agreement/sign', data)
}
export const getPayInfo = function (data) {
    return http('POST', '', '/trade/pay/info', data)
}
export const getLastAgreementName = function (data) {
    return http('POST', 'form', '/agreement/signature/last', data)
}
export const previewAgreement = function (data) {
    return http('POST', '', '/agreement/preview', data)
}

export const getProviderTerms = function (data) {
    return http('POST', '', '/trade/provider/terms', data, true)
}
/**
 * 请求JSON数据并处理成对象
 * @param {string} url - 请求地址
 * @param {Object} options - 请求选项
 * @returns {Promise<Object>} 解析后的JSON对象
 */
export const fetchJsonToObject = async (url, options = {}) => {
    try {
        // 设置默认选项
        const defaultOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        // 合并选项
        const requestOptions = Object.assign(defaultOptions, options);
        
        // 使用axios发起请求
        const response = await axios({
            url,
            ...requestOptions
        });
        
        // 返回数据
        return response.data;
    } catch (error) {
        console.error('Error fetching JSON data:', error);
        throw error;
    }
}